module.exports = __webpack_public_path__ + "static/media/star-sml.e8578f2a.svg";